<template>
  <div>
  <!--  奖金转电子币-->
    <app-breadcrumb />
    <div class="page-container">
      <el-form label-width="130px">
        <el-row>
          <!--      创建时间  -->
          <el-col :span="14">
            <div>
              <el-form-item :label="$t('Common.createTime')">
                <el-date-picker
                    v-model.trim="listQuery.createTimeStart"
                    type="date"
                    size="mini"
                    style="width: 140px;"
                    value-format="yyyy-MM-dd"
                    placeholder=""
                />&nbsp;&nbsp; - &nbsp;&nbsp;
                <el-date-picker
                    v-model.trim="listQuery.createTimeEnd"
                    type="date"
                    size="mini"
                    style="width: 140px;"
                    value-format="yyyy-MM-dd"
                    placeholder=""
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <!--          搜索-->
            <el-button size="small" :loading="btnloading" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
<!--            新增-->
            <el-button :loading="btnloading" size="small" type="success" icon="el-icon-plus" @click="addBtn">{{ $t('status.new') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <!--  用户编号-->
        <el-table-column :label="$t('fiPayAdvice.userCode')" prop="userCode" align="center"/>
        <!--  转换后金额-->
        <el-table-column :label="$t('Conversion.Amount')" prop="exMoneyLocal" align="center"/>
        <!--  转换汇率-->
        <el-table-column :label="$t('Conversion.Rate')" prop="rate" align="center"/>
        <!--  创建人-->
        <el-table-column :label="$t('pmProductSppm.createUser')" prop="creatorCode" align="center"/>
        <!-- 创建时间 -->
        <el-table-column :label="$t('Common.createTime')" prop="createTime" align="center"/>
        <!-- 状态 -->
        <el-table-column :label="$t('fiBankbookTemp.status')" prop="status" align="center">
          <template v-slot="{row}">
<!--            {{ $lt(initDict.status, row.status) }}-->
            <div v-if="row.status===0">{{ $t('status.new') }}</div>
            <div v-if="row.status===1">{{ $t('button.audit') }}</div>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column :label="$t('poReturn.createRemark')" prop="remark" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {pageByDTO} from "@/api/fi/acFbexcash";
import Pagination from "@/components/Pagination";

export default {
  name: "BonusElectronicCurrency",
  components: { Pagination },
  data(){
    return{
      btnloading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
    }
  },
  methods:{
//  搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.btnloading = true
      this.listLoading = true
      pageByDTO({ ...this.listQuery }).then(res => {
        this.list = res.data.records
        this.total = +res.data.total
        this.btnloading = false
        this.listLoading = false
      }).catch(err => {
        console.error(err)
        this.btnloading = false
        this.listLoading = false
      })
    },
    addBtn() {
      this.$router.push({name: 'BonusElectronicCurrencyAdd'})
    },
  }
}
</script>

<style scoped>

</style>
